import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const loginSendPhoneSchema = (t: TFunction) => Yup.object({
  phone: Yup.string()
    .min(6, t("onboarding.login.selectOption.yupSchema.character_number"))
    .required(t("onboarding.login.selectOption.yupSchema.require")),
  prefixPhone: Yup.string().required(t("onboarding.login.selectOption.yupSchema.require_prefix")),
});
